import { Component, inject } from '@angular/core';

import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { wideModalConfig } from '../../../consts/modal-config.const';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddUserComponent } from '../../location-admin/add-user/add-user.component';
import { CurrentUserService } from '../../../services/currentUser.service';

@Component({
  selector: 'app-mladmin-info',
  imports: [MatDividerModule, MatIconModule, MatButtonModule, MatCardModule],
  templateUrl: './mladmin-info.component.html'
})
export class MlAdminInfoComponent {
  infoMap: { icon: string; label: string; value: string }[] = [
    {
      icon: 'domain',
      label: 'Username',
      value: 'username'
    },
    {
      icon: 'badge',
      label: 'First name',
      value: 'firstName'
    },
    {
      icon: 'badge',
      label: 'Last name',
      value: 'lastName'
    },
    {
      icon: 'call',
      label: 'Phone Number',
      value: 'phone'
    },
    {
      icon: 'email',
      label: 'Email',
      value: 'emailAddress'
    }
  ];

  dialog = inject(MatDialog);
  currentUserService = inject(CurrentUserService);

  openEditUserModal() {
    const dialogConfig: MatDialogConfig = {
      ...wideModalConfig,
      data: { user: this.currentUserService.currentUserValue }
    };
    this.dialog.open(AddUserComponent, dialogConfig);
  }
}
